import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ClickOutside from 'components/ClickOutside';
import DayPicker, { DateUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import './index.scss';

class DayRangePicker extends Component {
  static propTypes = {
    value: PropTypes.shape({
      from: PropTypes.any,
      to: PropTypes.any,
    }),
    format: PropTypes.string,
    displayFormat: PropTypes.string,
    onChange: PropTypes.func,
    dayPickerProps: PropTypes.object,
    clearable: PropTypes.bool,
    disableFuture: PropTypes.bool,
  };

  static defaultProps = {
    value: {
      from: null,
      to: null,
    },
    format: '',
    displayFormat: '',
    dayPickerProps: {},
    clearable: true,
    disableFuture: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      pickerOpen: false,
      value: this.parseValue(props.value),
    };
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.value) !== JSON.stringify(this.props.value)) {
      this.setState({ value: this.parseValue(this.props.value) });
    }
  }

  handleDayClick(day, modifiers = {}) {
    if (modifiers.disabled) {
      return;
    }
    const { from, to } = DateUtils.addDayToRange(
      day,
      this.parseValue(this.state.value)
    );
    this.setState({ value: { from, to } }, () => {
      // If both From and To are filled in trigger the onChange
      if (this.state.value.to && this.state.value.from) {
        this.props.onChange(this.formatValue(this.state.value));
      }
    });
  }

  formatValue(rawValue) {
    const { from, to } = rawValue;
    return {
      from: from ? moment(from).format(this.props.format) : null,
      to: to ? moment(to).format(this.props.format) : null,
    };
  }

  parseValue(formattedValue) {
    if (!formattedValue) {
      return { from: null, to: null };
    }
    const { from, to } = formattedValue;
    return {
      from: from ? moment(from, this.props.format).toDate() : null,
      to: to ? moment(to, this.props.format).toDate() : null,
    };
  }

  displayValue(formattedValue) {
    const { from, to } = formattedValue || { from: null, to: null };
    return {
      from: from
        ? moment(from, this.props.format).format(this.props.displayFormat)
        : 'From',
      to: to
        ? moment(to, this.props.format).format(this.props.displayFormat)
        : 'To',
    };
  }

  openPicker() {
    this.setState({ pickerOpen: true });
  }

  closePicker() {
    this.setState({ pickerOpen: false });
  }

  clearPicker() {
    this.props.onChange({ from: null, to: null });
  }

  render() {
    const { from, to } = this.parseValue(this.state.value);
    const displayValue = this.displayValue(this.state.value);
    const modifiers = { start: from, end: to };
    const disabledDays = this.props.disableFuture ? { after: new Date() } : {};
    return (
      <div className="DayRangePicker">
        <div
          className="DayRangePicker-display gecko-ui-material form-control"
          onClick={this.openPicker.bind(this)}
        >
          <span>{displayValue.from}</span>
          <span className="DayRangePicker-display-seperator">
            <i className="far fa-long-arrow-right"></i>
          </span>
          <span>{displayValue.to}</span>
          {this.props.clearable && (from || to) ? (
            <span
              className="DayRangePicker-display-clear"
              title="Clear"
              onClick={this.clearPicker.bind(this)}
            >
              <i className="far fa-times"></i>
            </span>
          ) : null}
        </div>
        {this.state.pickerOpen ? (
          <ClickOutside onClickOutside={this.closePicker.bind(this)}>
            <DayPicker
              numberOfMonths={2}
              selectedDays={[from, { from, to }]}
              modifiers={modifiers}
              disabledDays={disabledDays}
              onDayClick={this.handleDayClick.bind(this)}
              {...this.props.dayPickerProps}
            />
          </ClickOutside>
        ) : null}
      </div>
    );
  }
}

export default DayRangePicker;
